import { ComponentType } from 'react';
import { UserRole } from '@synergy/models';

import { AccessControl } from './access-control';

export const AccessControlConnectRole =
    (allowedRoles?: UserRole | UserRole[], redirect = false) =>
    <P extends object>(WrappedComponent: ComponentType<P>) =>
    (props: P) =>
        (
            <AccessControl allowedRoles={allowedRoles} redirect={redirect}>
                <WrappedComponent {...props} />
            </AccessControl>
        );
